import { render, staticRenderFns } from "./img-import.vue?vue&type=template&id=70cf3de3&scoped=true&"
import script from "./img-import.vue?vue&type=script&lang=js&"
export * from "./img-import.vue?vue&type=script&lang=js&"
import style0 from "./img-import.vue?vue&type=style&index=0&id=70cf3de3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf3de3",
  null
  
)

export default component.exports